import React from "react";
import { Card, Statistic } from "antd";
import { motion } from "framer-motion";

interface MetricCardProps {
  title: string;
  value: number | string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  valueColor?: string;
  delay?: number;
  trend?: "up" | "down" | "stable";
  trendValue?: string;
  precision?: number;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  valueColor = "#1890ff",
  delay = 0,
  trend,
  trendValue,
  precision,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay }}
      whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
    >
      <Card
        style={{
          height: "100%",
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          border: "1px solid #e8e8e8",
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: delay + 0.2 }}
        >
          <Statistic
            title={title}
            value={value}
            prefix={prefix}
            suffix={suffix}
            valueStyle={{ color: valueColor, fontWeight: 600 }}
            precision={precision}
          />
          {trend && trendValue && (
            <motion.div
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: delay + 0.3 }}
              style={{ marginTop: 8, fontSize: 12 }}
            >
              <span
                style={{
                  color: trend === "up" ? "#ff4d4f" : trend === "down" ? "#52c41a" : "#1890ff",
                }}
              >
                {trendValue}
              </span>
            </motion.div>
          )}
        </motion.div>
      </Card>
    </motion.div>
  );
};
